



































































































































































































import { Component, PropSync } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import InputCode from '@/components/molecules/InputCode/InputCode.vue'
import {
  AlertMessage,
  ErrorMessage,
  uploadApi,
  UploadImageRequest
} from '@/api'
import { alertStore, modalErrorStore } from '@/utils/store-accessor'
import { MaskPattern, Prefix } from '@/types'

export interface MagazineVolumeEditBibliographyInfoItem {
  prefix: Prefix
  bibliographyRealId: number
  materialFormat: {
    input: string
    errorMessage: string
  }
  continuationStatus: {
    input: string
    errorMessage: string
  }
  magazineCode: {
    input: string
    errorMessage: string
  }
  classNo: {
    input: string
    errorMessage: string
  }
  edition: {
    input: string
    errorMessage: string
  }
  publicationYear: {
    input: string
    errorMessage: string
  }
  price: {
    input: string
    errorMessage: string
  }
  displayPrice: {
    input: string
    errorMessage: string
  }
  size: {
    input: string
    errorMessage: string
  }
  page: {
    input: string
    errorMessage: string
  }
  imageFile: {
    input: string
  }
  _imageFileDelete: {
    input: boolean
  }
}

export const defaultMagazineVolumeEditBibliographyInfoItem = (): MagazineVolumeEditBibliographyInfoItem => ({
  prefix: Prefix.Real,
  bibliographyRealId: 0,
  materialFormat: {
    input: '',
    errorMessage: ''
  },
  continuationStatus: {
    input: '',
    errorMessage: ''
  },
  magazineCode: {
    input: '',
    errorMessage: ''
  },
  classNo: {
    input: '',
    errorMessage: ''
  },
  edition: {
    input: '',
    errorMessage: ''
  },
  publicationYear: {
    input: '',
    errorMessage: ''
  },
  price: {
    input: '',
    errorMessage: ''
  },
  displayPrice: {
    input: '',
    errorMessage: ''
  },
  size: {
    input: '',
    errorMessage: ''
  },
  page: {
    input: '',
    errorMessage: ''
  },
  imageFile: {
    input: ''
  },
  _imageFileDelete: {
    input: false
  }
})

@Component({
  components: { InputCode }
})
export default class MagazineVolumeEditBibliographyInfo extends ComponentVue {
  @PropSync('input', {
    type: Object,
    required: true
  })
  inputItem!: MagazineVolumeEditBibliographyInfoItem

  uploading: boolean = false

  get alphaMarkNumberOnlyMask(): string {
    return MaskPattern.AlphaMarkNumberOnly
  }

  get bibliographyId(): string {
    return (
      this.inputItem.prefix +
      this.inputItem.bibliographyRealId.toString().padStart(10, '0')
    )
  }

  get publicationYearMask(): string {
    return '#'.repeat(3000)
  }

  get priceMask(): string {
    return '#'.repeat(7)
  }

  get eraseButtonColor() {
    return this.inputItem._imageFileDelete.input ? '#4769CB' : 'grey lighten-1'
  }

  existsErrorMessage(errorMessage: string): boolean {
    return errorMessage !== ''
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  onClickSelect(): void {
    const element = document.getElementById('file')
    if (element) {
      element.click()
    }
  }

  onChangeFile(event: Event): void {
    this.inputItem.imageFile.input = ''
    const files = (event.target as HTMLInputElement).files
    if (files !== null && files.length === 1) {
      this.upload(files[0])
    }
  }

  async upload(file: File) {
    const formData = new FormData()
    formData.append('image', file)

    const request: UploadImageRequest = {
      data: formData
    }

    this.uploading = true

    try {
      const response = await uploadApi.image(request)

      this.inputItem.imageFile.input = response.fileName
      this.uploading = false
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.uploading = false
    }
  }

  toggleImageFileDelete(): void {
    this.inputItem._imageFileDelete.input = !this.inputItem._imageFileDelete
      .input
  }
}
